const state = {
	courses: [],
	page: {
		pageIndex: 1,
		totalCourses: 0,
		itemPerPage: 10
	},
	search: '',
	filters: {
		openEnroll: false,
		archived: false,
		teachers: [],
		grades: [],
		subject: ''
	},
	courseState: '',
}

const mutations = {
	'Set_Courses'(state, courses) {
		state.courses = courses;
	},
	'Add_Course'(state, course) {
		if (course) {
			state.courses.push(course);
		}
	},
	'Remove_Course'(state, course) {
		state.courses.splice(
			state.courses.findIndex(c => c.googleCourseId == course.googleCourseId),
			1
		);
		// state.courses.splice(
		// 	state.courses.findIndex(c => c.id == course.id),
		// 	1
		// );
	},
	'Update_Course'(state, course) {
		state.courses.splice(
			state.courses.findIndex(c => c.id == course.id),
			1, course
		);
		// const index = state.courses.findIndex(c => c.id == course.id);
		// // const index = state.courses.findIndex(c => c.id == course.id);
		// state.courses[index] = course;
	},
	Set_CM_Page(state, page) {
		state.page = page;
	},
	Set_CM_Search(state, search) {
		state.search = search;
	},
	Set_CM_Filters_grades(state, grades){
		state.filters.grades = grades;
	},
	Set_CM_Filters_subject(state, subject){
		state.filters.subject = subject;
	},
	Set_CM_Filters_teachers(state, teachers){
		state.filters.teachers = teachers;
	},
	Set_CM_Filters_openEnroll(state, openEnroll){
		state.filters.openEnroll = openEnroll;
	},
	Set_CM_Filters_archived(state, archived){
		state.filters.archived = archived;
	},
	Set_CM_Filters_courseState(state, courseState){
		state.courseState = courseState;
	}
}

const actions = {
	addCourse({ commit }, course) {
		commit('Add_Course', course);
	},
	removeCourse({ commit }, course) {
		commit('Remove_Course', course);
	},
	updateCourse({ commit }, course) {
		commit('Update_Course', course);
	},
	setCourses({ commit }, courses) {
		commit('Set_Courses', courses);
	},
	setCMPage({ commit }, page) {
		commit('Set_CM_Page', page);
	},
	setCMSearch({ commit }, page) {
		commit('Set_CM_Search', page);
	},
	setCMGrades({ commit }, grades) {
		commit('Set_CM_Filters_grades', grades);
	},
	setCMSubject({ commit }, subject) {
		commit('Set_CM_Filters_subject', subject);
	},
	setCMTeachers({ commit }, teachers) {
		commit('Set_CM_Filters_teachers', teachers);
	},
	setCMOpenEnroll({ commit }, openEnroll) {
		commit('Set_CM_Filters_openEnroll', openEnroll);
	},
	setCMArchived({ commit }, archived) {
		commit('Set_CM_Filters_archived', archived);
	},
	setCMCourseState({ commit }, courseState) {
		commit('Set_CM_Filters_courseState', courseState);
	},
}

const getters = {
	courses: (state) => {
		return state.courses;
	},
	cmPage: (state) => {
		return state.page;
	},
	cmSearch: (state) => {
		return state.search;
	},
	cmFilters: (state) => {
		return state.filters;
	},
	cmCourseState: (state) => {
		return state.courseState;
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}